import React from 'react';
import AntIcon from '@ant-design/icons';
import './styles.scss';

const Icon = ({ component, ...rest }) => {
  return <AntIcon component={component} {...rest} />;
};

Icon.propTypes = {};

export default Icon;

import { ReactComponent as ArrowUp } from 'assets/images/icons/ArrowUp.svg';
import { ReactComponent as ArrowUpIcon } from 'assets/images/icons/ArrowUpIcon.svg';
import { ReactComponent as CheckedIcon } from 'assets/images/icons/CheckedIcon.svg';
import { ReactComponent as ChervonLeftIcon } from 'assets/images/icons/ChervonLeftIcon.svg';
import { ReactComponent as ChervonRightIcon } from 'assets/images/icons/ChervonRightIcon.svg';
import { ReactComponent as ClockIcon } from 'assets/images/icons/ClockIcon.svg';
import { ReactComponent as CloseIcon } from 'assets/images/icons/CloseIcon.svg';
import { ReactComponent as CustomerIcon } from 'assets/images/icons/CustomerIcon.svg';
import { ReactComponent as EditIcon } from 'assets/images/icons/EditIcon.svg';
import { ReactComponent as EmailIcon } from 'assets/images/icons/EmailIcon.svg';
import { ReactComponent as ErrorIcon } from 'assets/images/icons/ErrorIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/images/icons/FilterIcon.svg';
import { ReactComponent as KeyIcon } from 'assets/images/icons/KeyIcon.svg';
import { ReactComponent as MoreHorizontalIcon } from 'assets/images/icons/MoreHorizontalIcon.svg';
import { ReactComponent as ResetPasswordIcon } from 'assets/images/icons/ResetPasswordIcon.svg';
import { ReactComponent as SearchIcon } from 'assets/images/icons/SearchIcon.svg';
import { ReactComponent as StaffIcon } from 'assets/images/icons/StaffIcon.svg';
import { ReactComponent as TrashIcon } from 'assets/images/icons/TrashIcon.svg';
import { ReactComponent as ViewModuleIcon } from 'assets/images/icons/ViewModuleIcon.svg';
import { ReactComponent as ViewDetailsIcon } from 'assets/images/icons/ViewDetailsIcon.svg';
import { ReactComponent as QuestionMark } from 'assets/images/icons/QuestionMark.svg';
import { ReactComponent as RoleAdmin } from 'assets/images/icons/RoleAdmin.svg';
import { ReactComponent as RoleAnalyticsManager } from 'assets/images/icons/RoleAnalyticsManager.svg';
import { ReactComponent as RoleCampaignManager } from 'assets/images/icons/RoleCampaignManager.svg';
import { ReactComponent as DeleteWarning } from 'assets/images/icons/Warning.svg';
import { ReactComponent as RankIcon } from 'assets/images/icons/RankIcon.svg';
import { ReactComponent as LauchedIcon } from 'assets/images/icons/LauchedIcon.svg';
import { ReactComponent as LogoutIcon } from 'assets/images/icons/LogoutIcon.svg';
import { ReactComponent as ProfileIcon } from 'assets/images/icons/ProfileIcon.svg';
import { ReactComponent as ChangePWIcon } from 'assets/images/icons/ChangePWIcon.svg';
import { ReactComponent as WalletIcon } from 'assets/images/icons/WalletIcon.svg';
import { ReactComponent as DollarIcon } from 'assets/images/icons/DollarIcon.svg';
import { ReactComponent as StripIcon } from 'assets/images/icons/StripIcon.svg';
import { ReactComponent as SSLIcon } from 'assets/images/icons/SSLIcon.svg';
import { ReactComponent as VisaIcon } from 'assets/images/icons/VisaIcon.svg';
import { ReactComponent as MasterIcon } from 'assets/images/icons/MasterIcon.svg';
import { ReactComponent as NextIcon } from 'assets/images/icons/Next.svg';
import { ReactComponent as CardMTIcon } from 'assets/images/icons/Card-MT.svg';
import { ReactComponent as Plus } from 'assets/images/icons/Plus.svg';
import { ReactComponent as BankIcon } from 'assets/images/icons/BankIcon.svg';
import { ReactComponent as NoPaymentIcon } from 'assets/images/icons/NoPaymentIcon.svg';
import { ReactComponent as VisaLightIcon } from 'assets/images/icons/VisaLightIcon.svg';
import { ReactComponent as MasterLightIcon } from 'assets/images/icons/MasterLightIcon.svg';
import { ReactComponent as ArrowRightIcon } from 'assets/images/icons/ArrowRightIcon.svg';
import { ReactComponent as LibraryIcon } from 'assets/images/icons/LibraryIcon.svg';
import { ReactComponent as RightIcon } from 'assets/images/icons/RightIcon.svg';
import { ReactComponent as DoubleArrow } from 'assets/images/icons/DoubleArrow.svg';
import { ReactComponent as GrayAddIcon } from 'assets/images/icons/GrayAddIcon.svg';
import { ReactComponent as FilePreview } from 'assets/images/icons/FilePreview.svg';
import { ReactComponent as SirenErrorIcon } from 'assets/images/icons/SirenErrorIcon.svg';
import { ReactComponent as CopyIcon } from 'assets/images/icons/CopyIcon.svg';
import { ReactComponent as UploadIcon } from 'assets/images/icons/UploadIcon.svg';
import { ReactComponent as CheckIcon } from 'assets/images/icons/CheckIcon.svg';
import { ReactComponent as AddIcon } from 'assets/images/icons/AddIcon.svg';
import { ReactComponent as BannerImage } from 'assets/images/icons/banner-image.svg';
import { ReactComponent as VideoImage } from 'assets/images/icons/video-image.svg';
import { ReactComponent as CodeIcon } from 'assets/images/icons/CodeIcon.svg';
import { ReactComponent as UploadFileIcon } from 'assets/images/icons/UploadFileIcon.svg';
import { ReactComponent as LibraryUploadIcon } from 'assets/images/icons/LibraryUploadIcon.svg';
import { ReactComponent as TVIcon } from 'assets/images/icons/TVIcon.svg';
import { ReactComponent as PrerollIcon } from 'assets/images/icons/PrerollIcon.svg';
import { ReactComponent as NativeIcon } from 'assets/images/icons/NativeIcon.svg';
import { ReactComponent as PrerollBgIcon } from 'assets/images/icons/PrerollBgIcon.svg';
import { ReactComponent as NativeBgIcon } from 'assets/images/icons/NativeBgIcon.svg';
import { ReactComponent as UploadingIcon } from 'assets/images/icons/UploadingIcon.svg';
import { ReactComponent as SquareCheckedIcon } from 'assets/images/icons/SquareCheckedIcon.svg';
import { ReactComponent as SquareUncheckedIcon } from 'assets/images/icons/SquareUncheckedIcon.svg';
import { ReactComponent as HideEyeIcon } from 'assets/images/icons/HideEye.svg';
import { ReactComponent as AdVideoIcon } from 'assets/images/icons/AdVideoIcon.svg';
import { ReactComponent as AdBannerIcon } from 'assets/images/icons/AdBannerIcon.svg';
import { ReactComponent as NextArrowIcon } from 'assets/images/icons/NextArrowIcon.svg';
import { ReactComponent as PreArrowIcon } from 'assets/images/icons/PreArrowIcon.svg';
import { ReactComponent as CloudDownloadIcon } from 'assets/images/icons/CloudDownloadIcon.svg';
import { ReactComponent as CloudUploadIcon } from 'assets/images/icons/CloudUploadIcon.svg';
import { ReactComponent as TransferRoleIcon } from 'assets/images/icons/TransferRoleIcon.svg';
import { ReactComponent as CampaignSnapshotIcon } from 'assets/images/icons/CampaignSnapshotIcon.svg';
import { ReactComponent as EyeIcon } from 'assets/images/icons/EyeIcon.svg';
import { ReactComponent as CloneIcon } from 'assets/images/icons/CloneIcon.svg';
import { ReactComponent as DaysIcon } from 'assets/images/icons/DaysIcon.svg';
import { ReactComponent as ComputerIcon } from 'assets/images/icons/ComputerIcon.svg';
import { ReactComponent as ViewabilityIcon } from 'assets/images/icons/ViewabilityIcon.svg';
import { ReactComponent as ScreenIcon } from 'assets/images/icons/ScreenIcon.svg';
import { ReactComponent as BudgetIcon } from 'assets/images/icons/BudgetIcon.svg';
import { ReactComponent as AgeIcon } from 'assets/images/icons/AgeIcon.svg';
import { ReactComponent as GenderIcon } from 'assets/images/icons/GenderIcon.svg';
import { ReactComponent as DollarHandIcon } from 'assets/images/icons/DollarHandIcon.svg';
import { ReactComponent as UserGroupIcon } from 'assets/images/icons/UserGroupIcon.svg';
import { ReactComponent as StoreIcon } from 'assets/images/icons/StoreIcon.svg';
import { ReactComponent as CartIcon } from 'assets/images/icons/CartIcon.svg';
import { ReactComponent as DownloadIcon } from 'assets/images/icons/DownloadIcon.svg';
import { ReactComponent as TagIcon } from 'assets/images/icons/TagIcon.svg';
import { ReactComponent as Calendar } from 'assets/images/icons/Calendar.svg';
import { ReactComponent as CreativeSpecIcon } from 'assets/images/icons/CreativeSpecIcon.svg';
import { ReactComponent as CreateByIcon } from 'assets/images/icons/CreateByIcon.svg';
import { ReactComponent as DemographicIcon } from 'assets/images/icons/DemographicIcon.svg';
import { ReactComponent as FolderIcon } from 'assets/images/icons/FolderIcon.svg';
import { ReactComponent as RecordIcon } from 'assets/images/icons/RecordIcon.svg';
import { ReactComponent as CanvaIcon } from 'assets/images/icons/CanvaIcon.svg';
import { ReactComponent as SupportIcon } from 'assets/images/icons/SupportIcon.svg';
import { ReactComponent as CartLgIcon } from 'assets/images/icons/CartLgIcon.svg';
import { ReactComponent as SmallCanvaIcon } from 'assets/images/icons/SmallCanvaIcon.svg';
import { ReactComponent as CampaignIcon } from 'assets/images/icons/CampaignIcon.svg';
import { ReactComponent as PaperIcon } from 'assets/images/icons/PaperIcon.svg';
import { ReactComponent as DesktopIcon } from 'assets/images/icons/DesktopIcon.svg';
import { ReactComponent as MobileWebIcon } from 'assets/images/icons/MobileWebIcon.svg';
import { ReactComponent as MobileInAppIcon } from 'assets/images/icons/MobileInAppIcon.svg';
import { ReactComponent as BigTVIcon } from 'assets/images/icons/BigTVIcon.svg';
import { ReactComponent as LocationAddIcon } from 'assets/images/icons/LocationAddIcon.svg';
import { ReactComponent as LocationExcludeIcon } from 'assets/images/icons/LocationExcludeIcon.svg';
import { ReactComponent as PeopleCelebratingIcon } from 'assets/images/icons/PeopleCelebratingIcon.svg';
import { ReactComponent as AddAudienceIcon } from 'assets/images/icons/AddAudienceIcon.svg';
import { ReactComponent as ExcludeAudienceIcon } from 'assets/images/icons/ExcludeAudienceIcon.svg';
import { ReactComponent as NarrowAudienceIcon } from 'assets/images/icons/NarrowAudienceIcon.svg';
import { ReactComponent as TelevisionIcon } from 'assets/images/icons/TelevisionIcon.svg';
import { ReactComponent as CampaignComputerIcon } from 'assets/images/icons/CampaignComputerIcon.svg';
import { ReactComponent as PlayIcon } from 'assets/images/icons/PlayIcon.svg';
import { ReactComponent as StopIcon } from 'assets/images/icons/StopIcon.svg';
import { ReactComponent as PauseIcon } from 'assets/images/icons/PauseIcon.svg';
import { ReactComponent as AccountIcon } from 'assets/images/icons/AccountIcon.svg';
import { ReactComponent as OwnTemplateIcon } from 'assets/images/icons/OwnTemplateIcon.svg';
import { ReactComponent as CreativeIcon } from 'assets/images/icons/CreativeIcon.svg';
import { ReactComponent as AudienceIcon } from 'assets/images/icons/AudienceIcon.svg';
import { ReactComponent as StartPageIcon } from 'assets/images/icons/StartPageIcon.svg';
import { ReactComponent as AnalyticsIcon } from 'assets/images/icons/AnalyticsIcon.svg';
import { ReactComponent as EstimatorIcon } from 'assets/images/icons/EstimatorIcon.svg';
import { ReactComponent as OpenFolderIcon } from 'assets/images/icons/OpenFolderIcon.svg';
import { ReactComponent as NotiIcon } from 'assets/images/icons/NotiIcon.svg';
import { ReactComponent as PreviewIcon } from 'assets/images/icons/PreviewIcon.svg';
import { ReactComponent as Group2Icon } from 'assets/images/icons/Group2Icon.svg';
import { ReactComponent as Group3Icon } from 'assets/images/icons/Group3Icon.svg';
import { ReactComponent as Group4Icon } from 'assets/images/icons/Group4Icon.svg';
import { ReactComponent as Group5Icon } from 'assets/images/icons/Group5Icon.svg';
import { ReactComponent as Group6Icon } from 'assets/images/icons/Group6Icon.svg';
import { ReactComponent as CampaignNewIcon } from 'assets/images/icons/CampaignNewIcon.svg';
import { ReactComponent as OpenLinkIcon } from 'assets/images/icons/OpenLinkIcon.svg';
import { ReactComponent as PercentUp } from 'assets/images/icons/PercentUp.svg';
import { ReactComponent as PercentDown } from 'assets/images/icons/PercentDown.svg';
import { ReactComponent as InternetIcon } from 'assets/images/icons/InternetIcon.svg';
import { ReactComponent as ShareIcon } from 'assets/images/icons/ShareIcon.svg';
import { ReactComponent as MenuIcon } from 'assets/images/icons/MenuIcon.svg';
import { ReactComponent as UserIcon } from 'assets/images/icons/UserIcon.svg';
import { ReactComponent as AvatarIcon } from 'assets/images/icons/AvatarIcon.svg';
import { ReactComponent as AvatarAddIcon } from 'assets/images/icons/AvatarAddIcon.svg';
import { ReactComponent as SelectionIcon } from 'assets/images/icons/SelectionIcon.svg';
import { ReactComponent as SaveCreativeIcon } from 'assets/images/icons/SaveCreativeIcon.svg';
import { ReactComponent as UploadCreativeIcon } from 'assets/images/icons/UploadCreativeIcon.svg';
import { ReactComponent as PurChaseTemplateIcon } from 'assets/images/icons/PurchaseTemplateIcon.svg';
import { ReactComponent as SwapIcon } from 'assets/images/icons/swap.svg';
import { ReactComponent as PoweredByBalance } from 'assets/images/icons/PoweredByBalance.svg';
import { ReactComponent as AmericanExpress } from 'assets/images/icons/AmericanExpress.svg';
import { ReactComponent as MasterCardWithText } from 'assets/images/icons/MasterCardWithText.svg';
import { ReactComponent as DisneyIcon } from 'assets/images/icons/DisneyIcon.svg';
import { ReactComponent as HuluIcon } from 'assets/images/icons/HuluIcon.svg';
import { ReactComponent as RokuLogo } from 'assets/images/icons/RokuLogo.svg';
import { ReactComponent as CTVIcon } from 'assets/images/icons/ctv.svg';
import { ReactComponent as GoogleIcon } from 'assets/images/icons/GoogleIcon.svg';
import { ReactComponent as Account2Icon } from 'assets/images/icons/Account2Icon.svg';
import { ReactComponent as ReferralCodeIcon } from 'assets/images/icons/ReferralCodeIcon.svg';
import { ReactComponent as CheckedCircleIcon } from 'assets/images/icons/CheckedCircleIcon.svg';
import { ReactComponent as ArrowOutUpRightIcon } from 'assets/images/icons/ArrowOutUpRightIcon.svg';
import { ReactComponent as BaselineCallIcon } from 'assets/images/icons/BaselineCall.svg';
import { ReactComponent as DashboardIcon } from 'assets/images/icons/DashboardIcon.svg';
import { ReactComponent as SignOutIcon } from 'assets/images/icons/SignOutIcon.svg';
import { ReactComponent as CardIcon } from 'assets/images/icons/CardIcon.svg';
import { ReactComponent as CopyIcon2 } from 'assets/images/icons/CopyIcon2.svg';
import { ReactComponent as Congratulation } from 'assets/images/icons/Congratulation.svg';
import { ReactComponent as DownOutlinedIcon } from 'assets/images/icons/DownOutlined.svg';
import { ReactComponent as UpOutlinedIcon } from 'assets/images/icons/UpOutlined.svg';
import { ReactComponent as LeftOutlinedIcon } from 'assets/images/icons/LeftOutlined.svg';
import { ReactComponent as RightOutlinedIcon } from 'assets/images/icons/RightOutlined.svg';
import { ReactComponent as VisaMethod } from 'assets/images/icons/VisaMethod.svg';
import { ReactComponent as MasterCardMethod } from 'assets/images/icons/MasterCardMethod.svg';
import { ReactComponent as CreditCardIcon } from 'assets/images/icons/CreditCard.svg';
import { ReactComponent as ApplePayIcon } from 'assets/images/icons/ApplePay.svg';
import { ReactComponent as ShopPayIcon } from 'assets/images/icons/ShopPay.svg';
import { ReactComponent as GooglePayIcon } from 'assets/images/icons/GoogleIcon.svg';
import { ReactComponent as PaysafeIcon } from 'assets/images/icons/Paysafe.svg';
import { ReactComponent as WebmoneyIcon } from 'assets/images/icons/Webmoney.svg';
import { ReactComponent as QiwiIcon } from 'assets/images/icons/Qiwi.svg';
import { ReactComponent as InteracIcon } from 'assets/images/icons/Interac.svg';
import { ReactComponent as SEPAIcon } from 'assets/images/icons/SEPA.svg';
import { ReactComponent as IdealIcon } from 'assets/images/icons/Ideal.svg';
import { ReactComponent as EtheriumIcon } from 'assets/images/icons/Etherium.svg';
import { ReactComponent as SofortIcon } from 'assets/images/icons/Sofort.svg';
import { ReactComponent as AffirmIcon } from 'assets/images/icons/Affirm.svg';
import { ReactComponent as BancontactIcon } from 'assets/images/icons/Bancontact.svg';
import { ReactComponent as BitcoinIcon } from 'assets/images/icons/Bitcoin.svg';
import { ReactComponent as DiscoverIcon } from 'assets/images/icons/Discover.svg';
import { ReactComponent as DinersClubIcon } from 'assets/images/icons/DinersClub.svg';
import { ReactComponent as WeChatIcon } from 'assets/images/icons/WeChat.svg';
import { ReactComponent as YandexIcon } from 'assets/images/icons/Yandex.svg';
import { ReactComponent as JCBIcon } from 'assets/images/icons/JCB.svg';
import { ReactComponent as PayPalIcon } from 'assets/images/icons/PayPal.svg';
import { ReactComponent as AMEXIcon } from 'assets/images/icons/AMEX.svg';
import { ReactComponent as BitcoinCashIcon } from 'assets/images/icons/BitcoinCash.svg';
import { ReactComponent as BitpayIcon } from 'assets/images/icons/Bitpay.svg';
import { ReactComponent as CitadeleIcon } from 'assets/images/icons/Citadele.svg';
import { ReactComponent as EloIcon } from 'assets/images/icons/Elo.svg';
import { ReactComponent as ForbrugsforeningenIcon } from 'assets/images/icons/Forbrugsforeningen.svg';
import { ReactComponent as giropayIcon } from 'assets/images/icons/giropay.svg';
import { ReactComponent as KlarnaIcon } from 'assets/images/icons/Klarna.svg';
import { ReactComponent as LightcoinIcon } from 'assets/images/icons/Lightcoin.svg';
import { ReactComponent as MaestroIcon } from 'assets/images/icons/Maestro.svg';
import { ReactComponent as AmazonIcon } from 'assets/images/icons/Amazon.svg';
import { ReactComponent as VerifoneIcon } from 'assets/images/icons/Verifone.svg';
import { ReactComponent as PayoneerIcon } from 'assets/images/icons/Payoneer.svg';
import { ReactComponent as UnionPayIcon } from 'assets/images/icons/UnionPay.svg';
import { ReactComponent as StripeIcon } from 'assets/images/icons/Stripe.svg';
import { ReactComponent as SkrillIcon } from 'assets/images/icons/Skrill.svg';
import { ReactComponent as AlipayIcon } from 'assets/images/icons/Alipay.svg';
import { ReactComponent as DefaultBankIcon } from 'assets/images/icons/DefaultBankIcon.svg';
import { ReactComponent as CapitalOneIcon } from 'assets/images/icons/CapitalOne.svg';
import { ReactComponent as BettermentIcon } from 'assets/images/icons/Betterment.svg';
import { ReactComponent as NAVYFEDERALIcon } from 'assets/images/icons/NAVYFEDERAL.svg';
import { ReactComponent as USAAIcon } from 'assets/images/icons/USAA.svg';
import { ReactComponent as WealthfrontIcon } from 'assets/images/icons/Wealthfront.svg';
import { ReactComponent as AmericanExpressSmallIcon } from 'assets/images/icons/AmericanExpressSmall.svg';
import { ReactComponent as HungTinTonIcon } from 'assets/images/icons/HungTinTon.svg';
import { ReactComponent as REGIONSIcon } from 'assets/images/icons/REGIONS.svg';
import { ReactComponent as PNCIcon } from 'assets/images/icons/PNC.svg';
import { ReactComponent as WellsFargoIcon } from 'assets/images/icons/WellsFargo.svg';
import { ReactComponent as CitizensBankIcon } from 'assets/images/icons/CitizensBank.svg';
import { ReactComponent as TDBankIcon } from 'assets/images/icons/TDBank.svg';
import { ReactComponent as USBankIcon } from 'assets/images/icons/USBank.svg';
import { ReactComponent as BankOfAmericaIcon } from 'assets/images/icons/BankOfAmerica.svg';
import { ReactComponent as CharlesSCHWABIcon } from 'assets/images/icons/CharlesSCHWAB.svg';
import { ReactComponent as CitibankIcon } from 'assets/images/icons/Citibank.svg';
import { ReactComponent as ChaseIcon } from 'assets/images/icons/Chase.svg';
import { ReactComponent as OneClickCuratedIcon } from 'assets/images/icons/OneClickCurated.svg';
import { ReactComponent as ReTargetingPixelIcon } from 'assets/images/icons/ReTargetingPixel.svg';
import { ReactComponent as VoterFileOrCrmIcon } from 'assets/images/icons/VoterFileOrCrm.svg';
import { ReactComponent as BuildACustomIcon } from 'assets/images/icons/BuildACustom.svg';
import { ReactComponent as PreviouslySavedIcon } from 'assets/images/icons/PreviouslySaved.svg';
import { ReactComponent as PlusOutlinedIcon } from 'assets/images/icons/PlusOutlined.svg';
import { ReactComponent as AdvertisersIcon } from 'assets/images/icons/Advertisers.svg';
import { ReactComponent as DisplayAndVideoIcon } from 'assets/images/icons/DisplayAndVideoIcon.svg';
import { ReactComponent as InfoIcon } from 'assets/images/icons/InfoIcon.svg';
import { ReactComponent as ArrowOutwardIcon } from 'assets/images/icons/ArrowOutwardIcon.svg';
import { ReactComponent as ArrowOutLeftIcon } from 'assets/images/icons/ArrowOutLeftIcon.svg';
import { ReactComponent as HandshakeIcon } from 'assets/images/icons/HandshakeIcon.svg';
import { ReactComponent as LocalPoliceIcon } from 'assets/images/icons/LocalPoliceIcon.svg';
import { ReactComponent as VolunteerActivismIcon } from 'assets/images/icons/VolunteerActivism.svg';
import { ReactComponent as SpanishSpeakingIcon } from 'assets/images/icons/SpanishSpeaking.svg';
import { ReactComponent as MailIcon } from 'assets/images/icons/MailIcon.svg';
import { ReactComponent as VoteIcon } from 'assets/images/icons/VoteIcon.svg';
import { ReactComponent as HistoryEduIcon } from 'assets/images/icons/HistoryEduIcon.svg';
import { ReactComponent as ApprovalIcon } from 'assets/images/icons/ApprovalIcon.svg';
import { ReactComponent as ArrowDown } from 'assets/images/icons/ArrowDown.svg';
import { ReactComponent as ArrowUp2 } from 'assets/images/icons/ArrowUp2.svg';
import { ReactComponent as FinalAudienceChart } from 'assets/images/icons/FinalAudienceChart.svg';
import { ReactComponent as GroupsIcon } from 'assets/images/icons/GroupsIcon.svg';
import { ReactComponent as DiversityIcon } from 'assets/images/icons/DiversityIcon.svg';
import { ReactComponent as DeleteOutline } from 'assets/images/icons/DeleteOutline.svg';
import { ReactComponent as AdsClickIcon } from 'assets/images/icons/AdsClick.svg';
import { ReactComponent as TrendingUpIcon } from 'assets/images/icons/TrendingUp.svg';
import { ReactComponent as ViewInArIcon } from 'assets/images/icons/ViewInAr.svg';
import { ReactComponent as SlowMotionVideoIcon } from 'assets/images/icons/SlowMotionVideo.svg';
import { ReactComponent as AssignIcon } from 'assets/images/icons/AssignIcon.svg';
import { ReactComponent as Age2Icon } from 'assets/images/icons/Age2Icon.svg';
import { ReactComponent as ArrowCircleLeftIcon } from 'assets/images/icons/ArrowCircleLeftIcon.svg';
import { ReactComponent as ArrowCircleRightIcon } from 'assets/images/icons/ArrowCircleRightIcon.svg';
import { ReactComponent as ChildrenHouseholdIcon } from 'assets/images/icons/ChildrenHouseholdIcon.svg';
import { ReactComponent as ConnectedTVIcon } from 'assets/images/icons/ConnectedTVIcon.svg';
import { ReactComponent as Gender2Icon } from 'assets/images/icons/Gender2Icon.svg';
import { ReactComponent as BuildingHomeIcon } from 'assets/images/icons/BuildingHome.svg';
import { ReactComponent as PersonSyncIcon } from 'assets/images/icons/PersonSync.svg';
import { ReactComponent as FenceIcon } from 'assets/images/icons/Fence.svg';
import { ReactComponent as FireIcon } from 'assets/images/icons/Fire.svg';
import { ReactComponent as LocationCityIcon } from 'assets/images/icons/LocationCity.svg';
import { ReactComponent as OneClickGeneralIcon } from 'assets/images/icons/OneClickGeneralIcon.svg';
import { ReactComponent as PersonQuestionMarkIcon } from 'assets/images/icons/PersonQuestionMark.svg';
import { ReactComponent as SportsFootballIcon } from 'assets/images/icons/SportsFootball.svg';
import { ReactComponent as RoleAccountingAdmin } from 'assets/images/icons/RoleAccountingAdmin.svg';

import { ReactComponent as StarIcon } from 'assets/images/icons/StarIcon.svg';
import { ReactComponent as BusinessCenterIcon } from 'assets/images/icons/BusinessCenterIcon.svg';
import { ReactComponent as CurrencyExchangeIcon } from 'assets/images/icons/CurrencyExchangeIcon.svg';
import { ReactComponent as FinanceModeIcon } from 'assets/images/icons/FinanceModeIcon.svg';
import { ReactComponent as HomeWorkIcon } from 'assets/images/icons/HomeWorkIcon.svg';
import { ReactComponent as LandScape2Icon } from 'assets/images/icons/LandScape2Icon.svg';
import { ReactComponent as LuggageIcon } from 'assets/images/icons/LuggageIcon.svg';
import { ReactComponent as SavingIcon } from 'assets/images/icons/SavingIcon.svg';
import { ReactComponent as SportScoreIcon } from 'assets/images/icons/SportScoreIcon.svg';

import { ReactComponent as ShoppingBasketIcon } from 'assets/images/icons/ShoppingBasketIcon.svg';
import { ReactComponent as HowToRegIcon } from 'assets/images/icons/HowToRegIcon.svg';
import { ReactComponent as HowToVoteIcon } from 'assets/images/icons/HowToVoteIcon.svg';
import { ReactComponent as PublishedWithChangesIcon } from 'assets/images/icons/PublishedWithChangesIcon.svg';
import { ReactComponent as LanguageSpanishIcon } from 'assets/images/icons/LanguageSpanishIcon.svg';
import { ReactComponent as ChildCareIcon } from 'assets/images/icons/ChildCareIcon.svg';

export {
  SwapIcon,
  PurChaseTemplateIcon,
  ArrowUp,
  ArrowUpIcon,
  CheckedIcon,
  ChervonRightIcon,
  ChervonLeftIcon,
  ClockIcon,
  CloseIcon,
  CustomerIcon,
  EditIcon,
  EmailIcon,
  ErrorIcon,
  FilterIcon,
  KeyIcon,
  MoreHorizontalIcon,
  ResetPasswordIcon,
  SearchIcon,
  StaffIcon,
  TrashIcon,
  ViewModuleIcon,
  ViewDetailsIcon,
  QuestionMark,
  RoleAdmin,
  RoleCampaignManager,
  RoleAnalyticsManager,
  DeleteWarning,
  RankIcon,
  LauchedIcon,
  LogoutIcon,
  ProfileIcon,
  ChangePWIcon,
  WalletIcon,
  DollarIcon,
  StripIcon,
  SSLIcon,
  VisaIcon,
  MasterIcon,
  NextIcon,
  CardMTIcon,
  Plus,
  BankIcon,
  NoPaymentIcon,
  VisaLightIcon,
  MasterLightIcon,
  ArrowRightIcon,
  LibraryIcon,
  RightIcon,
  DoubleArrow,
  GrayAddIcon,
  FilePreview,
  SirenErrorIcon,
  CopyIcon,
  UploadIcon,
  CheckIcon,
  AddIcon,
  BannerImage,
  VideoImage,
  CodeIcon,
  UploadFileIcon,
  LibraryUploadIcon,
  TVIcon,
  PrerollIcon,
  NativeIcon,
  PrerollBgIcon,
  NativeBgIcon,
  UploadingIcon,
  SquareCheckedIcon,
  SquareUncheckedIcon,
  HideEyeIcon,
  AdVideoIcon,
  AdBannerIcon,
  NextArrowIcon,
  PreArrowIcon,
  CloudDownloadIcon,
  CloudUploadIcon,
  TransferRoleIcon,
  CampaignSnapshotIcon,
  EyeIcon,
  CloneIcon,
  DaysIcon,
  ComputerIcon,
  ViewabilityIcon,
  ScreenIcon,
  BudgetIcon,
  AgeIcon,
  GenderIcon,
  DollarHandIcon,
  UserGroupIcon,
  StoreIcon,
  CartIcon,
  DownloadIcon,
  TagIcon,
  Calendar,
  CreativeSpecIcon,
  CreateByIcon,
  DemographicIcon,
  FolderIcon,
  RecordIcon,
  CanvaIcon,
  SupportIcon,
  CartLgIcon,
  SmallCanvaIcon,
  CampaignIcon,
  PaperIcon,
  DesktopIcon,
  MobileWebIcon,
  MobileInAppIcon,
  BigTVIcon,
  LocationAddIcon,
  LocationExcludeIcon,
  PeopleCelebratingIcon,
  AddAudienceIcon,
  ExcludeAudienceIcon,
  NarrowAudienceIcon,
  TelevisionIcon,
  CampaignComputerIcon,
  PlayIcon,
  StopIcon,
  PauseIcon,
  AccountIcon,
  AudienceIcon,
  CreativeIcon,
  OwnTemplateIcon,
  StartPageIcon,
  AnalyticsIcon,
  EstimatorIcon,
  OpenFolderIcon,
  NotiIcon,
  PreviewIcon,
  Group2Icon,
  Group3Icon,
  Group4Icon,
  Group5Icon,
  Group6Icon,
  CampaignNewIcon,
  OpenLinkIcon,
  PercentUp,
  PercentDown,
  InternetIcon,
  ShareIcon,
  MenuIcon,
  UserIcon,
  AvatarIcon,
  AvatarAddIcon,
  SelectionIcon,
  SaveCreativeIcon,
  UploadCreativeIcon,
  PoweredByBalance,
  AmericanExpress,
  MasterCardWithText,
  DisneyIcon,
  HuluIcon,
  RokuLogo,
  CTVIcon,
  GoogleIcon,
  Account2Icon,
  ReferralCodeIcon,
  CheckedCircleIcon,
  ArrowOutUpRightIcon,
  BaselineCallIcon,
  DashboardIcon,
  SignOutIcon,
  CardIcon,
  CopyIcon2,
  Congratulation,
  DownOutlinedIcon,
  UpOutlinedIcon,
  LeftOutlinedIcon,
  RightOutlinedIcon,
  VisaMethod,
  MasterCardMethod,
  CreditCardIcon,
  ApplePayIcon,
  ShopPayIcon,
  GooglePayIcon,
  PaysafeIcon,
  WebmoneyIcon,
  QiwiIcon,
  InteracIcon,
  SEPAIcon,
  IdealIcon,
  EtheriumIcon,
  SofortIcon,
  AffirmIcon,
  BancontactIcon,
  BitcoinIcon,
  DiscoverIcon,
  DinersClubIcon,
  WeChatIcon,
  YandexIcon,
  JCBIcon,
  PayPalIcon,
  AMEXIcon,
  BitcoinCashIcon,
  BitpayIcon,
  CitadeleIcon,
  EloIcon,
  ForbrugsforeningenIcon,
  giropayIcon,
  KlarnaIcon,
  LightcoinIcon,
  MaestroIcon,
  AmazonIcon,
  VerifoneIcon,
  PayoneerIcon,
  UnionPayIcon,
  StripeIcon,
  SkrillIcon,
  AlipayIcon,
  DefaultBankIcon,
  CapitalOneIcon,
  BettermentIcon,
  NAVYFEDERALIcon,
  USAAIcon,
  WealthfrontIcon,
  AmericanExpressSmallIcon,
  HungTinTonIcon,
  REGIONSIcon,
  PNCIcon,
  WellsFargoIcon,
  CitizensBankIcon,
  TDBankIcon,
  USBankIcon,
  BankOfAmericaIcon,
  CharlesSCHWABIcon,
  CitibankIcon,
  ChaseIcon,
  OneClickCuratedIcon,
  ReTargetingPixelIcon,
  VoterFileOrCrmIcon,
  BuildACustomIcon,
  PreviouslySavedIcon,
  PlusOutlinedIcon,
  AdvertisersIcon,
  DisplayAndVideoIcon,
  InfoIcon,
  ArrowOutwardIcon,
  ArrowOutLeftIcon,
  HandshakeIcon,
  LocalPoliceIcon,
  VolunteerActivismIcon,
  SpanishSpeakingIcon,
  MailIcon,
  VoteIcon,
  HistoryEduIcon,
  ApprovalIcon,
  ArrowDown,
  ArrowUp2,
  FinalAudienceChart,
  GroupsIcon,
  DiversityIcon,
  DeleteOutline,
  AdsClickIcon,
  TrendingUpIcon,
  ViewInArIcon,
  SlowMotionVideoIcon,
  AssignIcon,
  Age2Icon,
  ArrowCircleLeftIcon,
  ArrowCircleRightIcon,
  ChildrenHouseholdIcon,
  ConnectedTVIcon,
  Gender2Icon,
  BuildingHomeIcon,
  PersonSyncIcon,
  FenceIcon,
  FireIcon,
  LocationCityIcon,
  OneClickGeneralIcon,
  PersonQuestionMarkIcon,
  SportsFootballIcon,
  RoleAccountingAdmin,
  StarIcon,
  BusinessCenterIcon,
  CurrencyExchangeIcon,
  FinanceModeIcon,
  HomeWorkIcon,
  LandScape2Icon,
  LuggageIcon,
  SavingIcon,
  SportScoreIcon,
  ShoppingBasketIcon,
  HowToRegIcon,
  HowToVoteIcon,
  PublishedWithChangesIcon,
  LanguageSpanishIcon,
  ChildCareIcon,
};
